import { ROUTE_KEYS } from '../const/route-keys';
import Home from '../pages/Home'
import Portfolio from '../pages/Portfolio'
import Timeline from '../pages/Timeline'


interface PageRouteInterface {
  path: string,
  component: object,
  key: string
}

export const menuRoutes: Array<PageRouteInterface> = [
  {
    path: '/',
    component: <Home />,
    key: ROUTE_KEYS.root,
  },
  {
    path: '/home',
    component: <Home />,
    key: ROUTE_KEYS.root,
  },
  {
    path: '/portfolio',
    component: <Portfolio />,
    key: 'portfolio',
  },
  {
    path: '/timeline',
    component: <Timeline />,
    key: 'timeline',
  },
];
